import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeToggleComponent } from '@/app/shared/components/theme-toggle/theme-toggle.component';
import { ParticlesComponent } from '@/app/shared/components/ui/particles/particles.component';
import { MagicCardComponent } from '@/app/shared/components/ui/magic-card/magic-card.component';

@Component({
  standalone: true,
  selector: 'app-our-mission',
  imports: [
    CommonModule,
    ThemeToggleComponent,
    ParticlesComponent,
    MagicCardComponent,
  ],
  templateUrl: './our-mission.component.html',
  styleUrl: './our-mission.component.scss',
})
export class OurMissionComponent {
  isMobileMenuOpen = false;
  isDarkTheme = true;

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
    }
  }

  onThemeChange(isDarkMode: boolean) {
    this.isDarkTheme = isDarkMode;
  }
}